import Snotify, {
    SnotifyPosition
} from 'vue-snotify'


export default {
    install(Vue, options) {

        const optionsDefaults = {
            toast: {
                position: SnotifyPosition.leftBottom,
                showProgressBar: false
            }
        }

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(Snotify, options)

    }
}
